import React, {useState} from "react";
import {QueryClient, QueryClientProvider} from "@tanstack/react-query";

type Props = {
  children?: React.ReactNode;
};

let queryClient: QueryClient | undefined;

function getQueryClient(): QueryClient {
  if (!queryClient) {
    queryClient = new QueryClient({
      defaultOptions: {
        queries: {
          retry: false,
          refetchOnWindowFocus: false,
        },
      },
    });
  }

  return queryClient;
}

export default function TanstackQueryManager(props: Props) {
  const [client] = useState<QueryClient>(() => {
    return getQueryClient();
  });

  return (
    <QueryClientProvider client={client}>
      {props.children}
    </QueryClientProvider>
  );
}
